import FormCreate, { zorynFormCreate } from '../../../../form-create/src/adapter'
import { bindZorynFormCreate } from '../../../../form-create/src/bind-components'

const viewForm = FormCreate

const designerForm = zorynFormCreate()
bindZorynFormCreate(designerForm)

export default viewForm

export { designerForm }
